/**
 * Module: search-results-filters.js
 * AJAX-powered filtering for dynamic search results
 * ! Compatible with new Twig-based theme structure !
 */

export default (enableDebug = false) => {
	var resultsWrapper = document.querySelector('#js-search-results');
	var filtersContainer = document.querySelector('.search-results-filters');
	var activeFiltersEl = filtersContainer ? filtersContainer.querySelector('.search-results-filters__active') : null;
	var activeFiltersList = activeFiltersEl ? activeFiltersEl.querySelector('.search-results-filters__active-filters') : null;
	var resultText = filtersContainer ? filtersContainer.querySelector('.search-results-filters__results-text') : null;
	var resetButton = document.getElementById('js-search-results-reset');
	var resultsToggle = document.getElementById('js-search-results-toggle');

	function getSelectedFilters() {
		var filters = {};
		document.querySelectorAll('.dropdown-menu__menu ul li a.is-active').forEach(function (link) {
			var url = new URL(link.href);
			url.searchParams.forEach(function (value, key) {
				if (key === 'sort') return;
				if (!value || !key || key === 's') return;
				if (!filters[key]) filters[key] = [];
				if (filters[key].indexOf(value) === -1) filters[key].push(value);
			});
		});

		return filters;
	}

	function updateDropdownCounts(filters) {
		document.querySelectorAll('.dropdown-menu').forEach(function (menu) {
			var btn = menu.querySelector('.dropdown-menu__button');
			var ul = menu.querySelector('ul');
			if (!btn || !ul) return;

			let terms = ul.querySelectorAll('a');
			let tax = null;
			let selectedCount = 0;

			terms.forEach(a => {
				var url = new URL(a.href);
				url.searchParams.forEach((value, key) => {
					if (!tax && key !== 's' && key !== 'sort') tax = key;
					if (a.classList.contains('is-active') && key !== 's' && key !== 'sort') {
						selectedCount++;
					}
				});
			});

			var countSpan = btn.querySelector('.--selected');
			if (selectedCount > 0) {
				if (!countSpan) {
					countSpan = document.createElement('span');
					countSpan.className = '--selected';
					btn.appendChild(countSpan);
				}
				countSpan.textContent = selectedCount;
			} else if (countSpan) {
				countSpan.remove();
			}
		});
	}

	function updateResetButtonState(filters) {
		if (!resetButton) return;
		if (Object.keys(filters).length === 0) {
			resetButton.classList.add('--disabled');
		} else {
			resetButton.classList.remove('--disabled');
		}
	}

	function renderActiveFilters(filters) {
		if (!activeFiltersList) return;
		activeFiltersList.innerHTML = '';
		Object.keys(filters).forEach(function (tax) {
			if (tax === 'post_type') return;
			filters[tax].forEach(function (term) {
				if (!term || !tax || tax === 's') return;
				if (activeFiltersList.querySelector('[data-tax="' + tax + '"][data-term="' + term + '"]')) return;
				var span = document.createElement('span');
				span.className = 'search-results-filters__active-filter button--search-tag';
				span.innerHTML = term +
					' <button class="js-remove-filter" data-tax="' + tax + '" data-term="' + term + '" aria-label="Remove filter">' +
					'<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
					'<path d="M11.0491 0L6 5.04909L0.950912 0L0 0.950912L5.04909 6L0 11.0491L0.950912 12L6 6.95091L11.0491 12L12 11.0491L6.95091 6L12 0.950912L11.0491 0Z" fill="#046195"></path>' +
					'</svg>' +
					'</button>';
				activeFiltersList.appendChild(span);
			});
		});
		if (activeFiltersEl) {
			activeFiltersEl.classList.toggle('--hidden', activeFiltersList.children.length === 0);
		}
		updateDropdownCounts(filters);
		updateResetButtonState(filters);
	}

	function updateSortDropdownText() {
		const activeSort = document.querySelector('.search-results-filters__refine-sort .dropdown-menu__menu a.is-active');
		const sortButton = document.querySelector('.search-results-filters__refine-sort .dropdown-menu__button');
		if (activeSort && sortButton) {
			sortButton.textContent = activeSort.textContent;
		}
	}

	function buildQueryParams(filters, paged = 1) {
		const params = new URLSearchParams();

		// Add selected filters to params
		Object.keys(filters).forEach(key => {
			params.set(key, filters[key].join(','));
		});

		// Add sort parameter if active
		const sortParam = getCurrentSortValue();
		if (sortParam) {
			params.set('sort', sortParam);
		}

		// Get search query from URL and add as 's' parameter
		const urlParams = new URLSearchParams(window.location.search);
		const searchQuery = urlParams.get('s') || '';
		if (searchQuery) {
			params.set('s', searchQuery);
		}

		// Add pagination and AJAX-specific params
		params.set('paged', paged);
		params.set('ajax', '1');
		params.set('action', 'search_results_filter');
		params.set('nonce', ajax_var.nonce);

		// Toggle state: inject post_type if resources-only is selected
		const selectedToggle = document.querySelector('input[name="search-type"]:checked');
		const isResourcesOnly = selectedToggle && selectedToggle.value === 'resources';

		if (isResourcesOnly) {
			params.set('post_type', 'resource');
		} else {
			params.delete('post_type');
		}

		return params.toString();
	}

	function getCurrentSortValue() {
		var activeSort = document.querySelector('.search-results-filters__refine-sort .dropdown-menu__menu a.is-active');
		if (activeSort) {
			var url = new URL(activeSort.href);
			return url.searchParams.get('sort');
		}
		return null;
	}

	function fetchSearchResults(filters, paged = 1) {
		var query = buildQueryParams(filters, paged);
		var endpoint = ajax_var.url + '?' + query;

		if (resultsWrapper) {
			resultsWrapper.classList.add('is-loading');
		}

		fetch(endpoint, {
			headers: { 'X-Requested-With': 'XMLHttpRequest' }
		})
			.then(res => res.json())
			.then(response => {
				if (!response.success) throw new Error('No success response from AJAX');

				window.lastSearchResponse = response;

				const html = response.data.html || '';
				const paginationHtml = response.data.pagination || '';
				const count = response.data.count || 0;
				const currentPage = response.data.paged || 1;
				const perPage = response.data.posts_per_page || 10;
				const htmlCount = response.data.htmlCount || 0;

				if (resultsWrapper) {
					resultsWrapper.innerHTML = '';

					if (html) {
						const tempDiv = document.createElement('div');
						tempDiv.innerHTML = html;
						const newItems = tempDiv.querySelector('.search-results__items');
						if (newItems) {
							resultsWrapper.appendChild(newItems);
						}
					}

					let paginationContainer = document.querySelector('.search-results-pagination');
					if (paginationHtml) {
						if (!paginationContainer) {
							paginationContainer = document.createElement('div');
							paginationContainer.className = 'search-results-pagination';
							resultsWrapper.parentNode.appendChild(paginationContainer);
						}
						paginationContainer.innerHTML = paginationHtml;
					}

					if (!html && !paginationHtml) {
						const noResults = document.createElement('h3');
						noResults.className = 'search-results__none-found';
						noResults.textContent = 'No results found';
						resultsWrapper.appendChild(noResults);
					}

					resultsWrapper.classList.remove('is-loading');

					const emptyBlock = document.querySelector('.search-results__empty');
					if (emptyBlock) emptyBlock.style.display = count === 0 ? 'block' : 'none';

					if (resultText) {
						if (count > 0) {
							const start = ((currentPage - 1) * perPage) + 1;
							const end = start + htmlCount - 1;
							resultText.textContent = `Showing results ${start}-${end} of ${count}`;
						} else {
							resultText.textContent = 'Showing 0 of 0 results';
						}
					}
				}

				bindPaginationEvents(filters, currentPage);
			})
			.catch(err => {
				console.error('Search AJAX error:', err);
				if (resultsWrapper) {
					resultsWrapper.classList.remove('is-loading');
				}
			});
	}

	function bindPaginationEvents(filters, currentPage) {
		document.querySelectorAll('.search-results-pagination a').forEach(anchor => {
			const newAnchor = anchor.cloneNode(true);
			anchor.parentNode.replaceChild(newAnchor, anchor);
		});

		document.querySelectorAll('.search-results-pagination a').forEach(link => {
			link.addEventListener('click', function(e) {
				e.preventDefault();
				let targetPage = parseInt(link.textContent.trim());

				if (link.classList.contains('prev')) {
					targetPage = currentPage - 1;
				} else if (link.classList.contains('next')) {
					targetPage = currentPage + 1;
				}

				if (!isNaN(targetPage)) {
					fetchSearchResults(filters, targetPage);
					const searchResultsSection = document.querySelector('.search-results');
					if (searchResultsSection) {
						searchResultsSection.scrollIntoView({ behavior: 'smooth' });
					}
				}
			});
		});
	}

	function resetAllFilters() {
		document.querySelectorAll('.dropdown-menu__menu ul li a.is-active').forEach(el => el.classList.remove('is-active'));

		const searchInput = document.querySelector('.search-results-form__input');
		if (searchInput) {
			searchInput.value = '';
			searchInput.placeholder = 'Search NCODA';
		}

		// Only toggle if currently set to Resources (value === 'resources')
		const selectedToggle = document.querySelector('input[name="search-type"]:checked');
		if (selectedToggle && selectedToggle.value === 'resources') {
			const fauxToggle = document.getElementById('fauxToggleResults');
			if (fauxToggle) {
				console.debug('[Reset] Forcing toggle to Everything');
				fauxToggle.click();
			}
		}

		renderActiveFilters({});
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.set('s', '');
		window.history.replaceState({}, '', currentUrl.toString());

		fetchSearchResults({});
		updateResetButtonState({});
	}

	function applyInitialFiltersFromURL() {
		const urlParams = new URLSearchParams(window.location.search);

		document.querySelectorAll('.dropdown-menu__menu ul li a').forEach(link => {
			const linkUrl = new URL(link.href);
			linkUrl.searchParams.forEach((value, key) => {
				if (key === 's' || key === 'sort') return;
				const param = urlParams.get(key);
				if (!param) return;

				if (param.split(',').includes(value)) {
					link.classList.add('is-active');
				}
			});
		});

		const currentSort = urlParams.get('sort');
		if (currentSort) {
			document.querySelectorAll('.search-results-filters__refine-sort .dropdown-menu__menu a').forEach(link => {
				const linkUrl = new URL(link.href);
				if (linkUrl.searchParams.get('sort') === currentSort) {
					link.classList.add('is-active');
					updateSortDropdownText();
				}
			});
		}

		const postType = urlParams.get('post_type');
		if (postType === 'resource') {
			const fauxToggle = document.getElementById('fauxToggleResults');
			if (fauxToggle) fauxToggle.click();
		}
	}

	if (filtersContainer) {
		filtersContainer.addEventListener('click', function (e) {
			if (e.target.matches('.dropdown-menu__menu a')) {
				e.preventDefault();
				e.target.classList.toggle('is-active');
				const filters = getSelectedFilters();
				renderActiveFilters(filters);
				fetchSearchResults(filters);
			}

			if (e.target.closest('.search-results-filters__refine-sort .dropdown-menu__menu a')) {
				e.preventDefault();
				document.querySelectorAll('.search-results-filters__refine-sort .dropdown-menu__menu a').forEach(link => link.classList.remove('is-active'));
				e.target.classList.add('is-active');
				updateSortDropdownText();
				const filters = getSelectedFilters();
				renderActiveFilters(filters);
				fetchSearchResults(filters);
			}

			if (e.target.matches('.js-remove-filter, .js-remove-filter *')) {
				const button = e.target.closest('.js-remove-filter');
				const tax = button.getAttribute('data-tax');
				const term = button.getAttribute('data-term');

				document.querySelectorAll('.dropdown-menu__menu ul li a.is-active').forEach(el => {
					const url = new URL(el.href);
					if (url.searchParams.get(tax) === term) {
						el.classList.remove('is-active');
					}
				});

				const parent = button.closest('.search-results-filters__active-filter');
				if (parent) parent.remove();

				const filters = getSelectedFilters();
				renderActiveFilters(filters);
				fetchSearchResults(filters);
			}
		});
	}

	if (resetButton) {
		resetButton.addEventListener('click', function () {
			resetAllFilters();
		});
	}

	if (resultsToggle) {
		resultsToggle.addEventListener('change', function () {
			const selectedToggle = document.querySelector('input[name="search-type"]:checked');
			const isResourcesOnly = selectedToggle && selectedToggle.value === 'resources';
			console.log('[Toggle] Toggle changed: resourcesOnly?', isResourcesOnly);

			const filters = getSelectedFilters();
			console.log('[Toggle] Filters BEFORE post_type injection:', JSON.parse(JSON.stringify(filters)));

			if (isResourcesOnly) {
				filters['post_type'] = ['resource'];
				console.log('[Toggle] post_type set to resource');
			} else {
				delete filters['post_type'];
				console.log('[Toggle] post_type removed (Everything)');
			}

			console.log('[Toggle] Filters AFTER post_type injection:', JSON.parse(JSON.stringify(filters)));

			renderActiveFilters(filters);
			fetchSearchResults(filters);
		});
	}

	const searchInput = document.querySelector('.search-results-form__input');
	const searchSubmitBtn = document.querySelector('.search-results-form__submit');
	if (searchInput) {
		searchInput.addEventListener('input', function() {
			if (searchInput.value === '') {
				searchInput.placeholder = 'Search NCODA';
				const currentUrl = new URL(window.location.href);
				currentUrl.searchParams.set('s', '');
				window.history.replaceState({}, '', currentUrl.toString());
			}
		});
	}

	if (searchSubmitBtn) {
		const searchForm = searchSubmitBtn.closest('form');
		if (searchForm) {
			searchForm.addEventListener('submit', function(e) {
				e.preventDefault();
				const searchKeyword = searchInput ? searchInput.value : '';
				const currentUrl = new URL(window.location.href);
				currentUrl.searchParams.set('s', searchKeyword);
				window.history.replaceState({}, '', currentUrl.toString());

				const filters = getSelectedFilters();
				fetchSearchResults(filters, 1);
				const searchResultsSection = document.querySelector('.search-results');
				if (searchResultsSection) {
					searchResultsSection.scrollIntoView({ behavior: 'smooth' });
				}
			});
		}
	}

	applyInitialFiltersFromURL();
	const initialFilters = getSelectedFilters();
	renderActiveFilters(initialFilters);
	fetchSearchResults(initialFilters);
};
